import { LitElement } from '~/lib/bn-lit-element';
import { css } from '../../utility/lit-entity';
import { DeviceMonitoringChartLayerLineMixin } from './device-monitoring-chart-layer-line-mixin';

export const colour = css`var(--orange-10)`;

export const hasWarning = () => false;
export const hasAlert = () => false;

class DeviceMonitoringChartLayerBatteryTemperature extends DeviceMonitoringChartLayerLineMixin(LitElement) {
  constructor() {
    super();
    this.dataKey = 'batteryTemperature';
    this.maxValue = 65;
    this.minValue = -30;
  }

  static get styles() {
    return [...super.styles, css`
      :host {
        --good-stroke: var(--orange-10);
        --warning-stroke: ${colour};
        --alert-stroke: var(--orange-30);
      }
    `];
  }
}

window.customElements.define('device-monitoring-chart-layer-battery-temperature', DeviceMonitoringChartLayerBatteryTemperature);
